<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'materialArticleDetail',
})
</script>
<template>
  <ArticleForm readonly />
</template>

<script setup lang="ts" name="materialArticleDetail">
import ArticleForm from './form.vue'
</script>
